module.exports = __webpack_public_path__ + "img/LC-cage.dd6fa7bb.png";